const id = 'syncedBalances'

export default id
